function timeDiference(zacatekPauzy) {
  // Aktuální čas a datum
  const aktualniCas = new Date();

  // Čas začátku pauzy
  const [h, m, s] = zacatekPauzy.split(':');
  const zacatekPauzyCas = new Date();
  zacatekPauzyCas.setHours(h, m, s, 0);

  // Výpočet rozdílu
  const rozdil = Math.floor((aktualniCas - zacatekPauzyCas) / (1000 * 60)); // V minutách

  return rozdil;
  }

export default timeDiference
